import { clinicsStore } from 'entities/clinics';
import { ClinicState } from 'entities/clinics/store/types';
import { observer } from 'mobx-react-lite';
import { ChangeEvent, FC } from 'react';
import { useDebounceCallback } from 'shared/lib/debounce';
import { Input } from 'shared/ui/input';

interface ClinicsSearchProps {
	updateClinics: (clinics: ClinicState[]) => void;
}

export const ClinicsSearch: FC<ClinicsSearchProps> = observer(
	({ updateClinics }) => {
		const search = useDebounceCallback(
			(value: ChangeEvent<HTMLInputElement>) => {
				const query: string = value.target.value;
				if (query) {
					const results = clinicsStore.clinics.filter(
						clinic =>
							clinic.name.toLocaleLowerCase().includes(query) ||
							clinic.info.some(infoItem =>
								infoItem.toLocaleLowerCase().includes(query),
							),
					);
					updateClinics(
						results.map(result => {
							return { ...result };
						}),
					);
				} else {
					updateClinics(
						clinicsStore.clinics.map(clinic => {
							return { ...clinic };
						}),
					);
				}
			},
			300,
		);

		return <Input placeholder="Название клиники" onChange={search} />;
	},
);
